'use client';

import { useState, useEffect } from 'react';
import DataTable from './DataTable';
import FilterControls from './FilterControls';
import StatsCards from './StatsCards';
import './FilterReport.css';

const FilterReport = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    case: '',
    status: '',
    startDate: '',
    endDate: '',
    client_url: '',
  });

  const API_BASE_URL = '/api';

  useEffect(() => {
    fetchLogs();
    fetchStats();
  }, []);

  useEffect(() => {
    fetchLogs();
  }, [filters]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();

      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });

      const response = await fetch(`${API_BASE_URL}/speech-logs?${queryParams}`);
      const data = await response.json();
      setLogs(data);
      setFilteredLogs(data);
    } catch (error) {
      console.error('Error fetching logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/speech-logs/stats`);
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const handleFilterChange = newFilters => {
    setFilters(newFilters);
  };

  const exportToCSV = () => {
    console.log('ccc', filteredLogs);
    const headers = [
      'sessionId',
      'DateTime',
      'Case',
      'UserInput',
      'LLMInput',
      'Response',
      'LLMResponseTime',
      'ClientURL',
      'Status',
      'ErrorLog',
    ];
    const csvContent = [
      headers.join(','),
      ...filteredLogs.map(log =>
        [
          `"${(log.sessionId || '').replace(/"/g, '""')}"`,
          `"${new Date(log.timestamp).toLocaleString().replace(/"/g, '""')}"`,
          //   log.case || "",
          `"${(log.case || '').replace(/"/g, '""')}"`,
          `"${(log.userInput || '').replace(/"/g, '""')}"`,
          // `"${(log.spokenText || "").replace(/"/g, '""')}"`,
          `"${(log.spokenText || '').replace(/"/g, '""').replace(/\n/g, ' ').replace(/\r/g, ' ')}"`,
          `"${(log.aiResponse || '').replace(/"/g, '""')}"`,
          `"${(log.totalResponseTime || '').replace(/"/g, '""')}"`,
          
          


          log.client_url || '',
          log.status || '',
          `"${(log.error || '').replace(/"/g, '""')}"`,
        ].join(',')
      ),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `speech-logs-${filters.case || 'all'}-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="main-container">
      <div className="pd-ltr-20 xs-pd-20-10">
        <div className="filter-report">
          <div className="report-header">
            <h2>Filter Report Dashboard</h2>
            <button onClick={exportToCSV} className="export-btn">
              Export to CSV
            </button>
          </div>

          <StatsCards stats={stats} />

          <FilterControls filters={filters} onFilterChange={handleFilterChange} />

          {loading ? <div className="loading">Loading...</div> : <DataTable logs={filteredLogs} />}
        </div>
      </div>
    </div>
  );
};

export default FilterReport;
